define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaWaterMovementMethodDomain = void 0;
    class WaWaterMovementMethodDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaWaterMovementMethodDomain.BoreDrains, value: "Bore Drains" },
                    { key: WaWaterMovementMethodDomain.PipingOrTransportingWater, value: "Piping or transporting water" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaWaterMovementMethodDomain.BoreDrains] = 0;
                this.KeyIndex[WaWaterMovementMethodDomain.PipingOrTransportingWater] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Bore Drains"] = 0;
                this.ValueIndex["Piping or transporting water"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaWaterMovementMethodDomain = WaWaterMovementMethodDomain;
    Object.defineProperty(WaWaterMovementMethodDomain, "BoreDrains", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaWaterMovementMethodDomain, "PipingOrTransportingWater", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaWaterMovementMethodDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
